/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SrvProceedingClaimSnapshotRowResponse } from './SrvProceedingClaimSnapshotRowResponse';
import {
    SrvProceedingClaimSnapshotRowResponseFromJSON,
    SrvProceedingClaimSnapshotRowResponseFromJSONTyped,
    SrvProceedingClaimSnapshotRowResponseToJSON,
    SrvProceedingClaimSnapshotRowResponseToJSONTyped,
} from './SrvProceedingClaimSnapshotRowResponse';

/**
 * 
 * @export
 * @interface SrvProceedingClaimsSnapshotResponse
 */
export interface SrvProceedingClaimsSnapshotResponse {
    /**
     * 
     * @type {Array<SrvProceedingClaimSnapshotRowResponse>}
     * @memberof SrvProceedingClaimsSnapshotResponse
     */
    rows: Array<SrvProceedingClaimSnapshotRowResponse>;
    /**
     * 
     * @type {number}
     * @memberof SrvProceedingClaimsSnapshotResponse
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof SrvProceedingClaimsSnapshotResponse
     */
    isStale: boolean;
}

/**
 * Check if a given object implements the SrvProceedingClaimsSnapshotResponse interface.
 */
export function instanceOfSrvProceedingClaimsSnapshotResponse(value: object): value is SrvProceedingClaimsSnapshotResponse {
    if (!('rows' in value) || value['rows'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('isStale' in value) || value['isStale'] === undefined) return false;
    return true;
}

export function SrvProceedingClaimsSnapshotResponseFromJSON(json: any): SrvProceedingClaimsSnapshotResponse {
    return SrvProceedingClaimsSnapshotResponseFromJSONTyped(json, false);
}

export function SrvProceedingClaimsSnapshotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SrvProceedingClaimsSnapshotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'rows': ((json['rows'] as Array<any>).map(SrvProceedingClaimSnapshotRowResponseFromJSON)),
        'total': json['total'],
        'isStale': json['isStale'],
    };
}

export function SrvProceedingClaimsSnapshotResponseToJSON(json: any): SrvProceedingClaimsSnapshotResponse {
    return SrvProceedingClaimsSnapshotResponseToJSONTyped(json, false);
}

export function SrvProceedingClaimsSnapshotResponseToJSONTyped(value?: SrvProceedingClaimsSnapshotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rows': ((value['rows'] as Array<any>).map(SrvProceedingClaimSnapshotRowResponseToJSON)),
        'total': value['total'],
        'isStale': value['isStale'],
    };
}

